import { selectHeader } from 'store/slices/GeneralSlice';

import { useSelector } from 'react-redux';
import ProductDropdown from './HeaderNavigationDropdownItem/ProductDropdown';
import FeaturesDropdown from './HeaderNavigationDropdownItem/FeaturesDropdown';
import CompanyDropdown from './HeaderNavigationDropdownItem/CompanyDropdown';

const HeaderNavigationDropdown = ({ item, isDropdownOpen, onClick }) => {
    const header = useSelector(selectHeader)

    return (
        <div className={`inner-container header-nav__item__dropdown
         ${isDropdownOpen ? "header-nav__item__dropdown-open" : "header-nav__item__dropdown-close"}`}>
            {item.name === header.products && <ProductDropdown items={item.items} onClick={onClick} />}
            {item.name === header.features && <FeaturesDropdown items={item.items} onClick={onClick} />}
            {item.name === header.company && <CompanyDropdown items={item.items} onClick={onClick} />}
        </div>
    );
};

export default HeaderNavigationDropdown;
